var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import styled from "styled-components";
import id from "@irati/utils/id";
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname";
import ProfilePic from "@irati/ui/src/ProfilePicture";
import { greys } from "@irati/ui/src/global/colors";
import padding from "@irati/ui/src/global/padding";
import { breakWord } from "@irati/ui/src/global/helpers";
import { Label2, Para as ParaBase } from "@irati/ui/src/Labels";
import { FormattedRelative } from "@irati/utils/lang";
import { CommentEditType } from "@irati/recognition/enums/Moderation";
import DeleteCommentMutation from "@irati/recognition/apollo/mutation/Comment/Delete";
import ModerateCommentMutation from "@irati/recognition/apollo/mutation/Comment/Moderate";
import Actions from "./Actions";
import UpdateComment from "./UpdateComment";
import ModeratedMessage from "../../../shared/Moderated";
import { ConfirmDeleteComment as ConfirmDeleteCommentBase, ConfirmRemoveComment as ConfirmRemoveCommentBase } from "../Confirm";
var DeleteCommentConfirm = styled(ConfirmDeleteCommentBase)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin-top: ", ";\n  z-index: 10;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin-top: ", ";\n  z-index: 10;\n"])), padding.base);
var ConfirmRemoveComment = styled(ConfirmRemoveCommentBase)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin-top: ", ";\n  z-index: 10;\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin-top: ", ";\n  z-index: 10;\n"])), padding.base);
var Container = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(61,61,54,0.25);\n  background-color: ", ";\n  padding: ", ";\n  border-radius: 3px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  border: 1px solid rgba(61,61,54,0.25);\n  background-color: ", ";\n  padding: ", ";\n  border-radius: 3px;\n"])), greys.white, padding.tiny);
var InfoContainer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex-grow: 2;\n"], ["\n  flex-grow: 2;\n"])));
var Para = styled(ParaBase)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  white-space: pre-line;\n"], ["\n  ", "\n  white-space: pre-line;\n"])), breakWord);
var BlackCircle = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: 40%;\n  vertical-align: middle;\n  padding: 0 4px;\n"], ["\n  display: inline-block;\n  font-size: 40%;\n  vertical-align: middle;\n  padding: 0 4px;\n"])));
var CreatedAtDate = styled(Label2)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), greys.medium);
var Footer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  position: relative;\n  justify-content: space-between;\n  align-items: center;\n"])));
var CommentComponent = /** @class */ (function (_super) {
    __extends(CommentComponent, _super);
    function CommentComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.enableUpdateMode = function () {
            var _a = _this.props, onEnableUpdateMode = _a.onEnableUpdateMode, comment = _a.comment;
            onEnableUpdateMode(comment.uuid, CommentEditType.UPDATE);
        };
        _this.disableUpdateMode = function () {
            _this.props.onDisableUpdateMode();
        };
        _this.enableDeleteMode = function () {
            var _a = _this.props, onEnableDeleteMode = _a.onEnableDeleteMode, comment = _a.comment;
            onEnableDeleteMode(comment.uuid, CommentEditType.DELETE);
        };
        _this.disableDeleteMode = function () {
            _this.props.onDisableDeleteMode();
        };
        _this.enableModerateMode = function () {
            var _a = _this.props, onEnableModerateMode = _a.onEnableModerateMode, comment = _a.comment;
            onEnableModerateMode(comment.uuid, CommentEditType.MODERATE);
        };
        _this.disableModerateMode = function () {
            _this.props.onDisableModerateMode();
        };
        return _this;
    }
    CommentComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, isUpdateMode = _a.isUpdateMode, isDeleteMode = _a.isDeleteMode, isModerateMode = _a.isModerateMode, item = _a.item, comment = _a.comment, className = _a.className;
        return (isUpdateMode
            ? React.createElement(UpdateComment, { item: item, comment: comment, onClickCancel: this.disableUpdateMode, onUpdateSuccess: this.disableUpdateMode })
            : (React.createElement(Container, { className: className },
                React.createElement(Para, null,
                    React.createElement(ModeratedMessage, { message: comment.message, isModerated: comment.moderated })),
                React.createElement(Footer, null,
                    React.createElement(InfoContainer, null,
                        React.createElement(ProfilePic, { user: comment.createdBy, small: true, marginRight: true, id: id("target", this.props) }),
                        React.createElement(Label2, null, firstnameLastname(comment.createdBy)),
                        React.createElement(BlackCircle, null, "\u00A0\u25CF\u00A0"),
                        React.createElement(CreatedAtDate, null,
                            React.createElement(FormattedRelative, { value: comment.updatedAt }))),
                    React.createElement(Actions, { pullRight: true, disabled: isUpdateMode || isDeleteMode || isModerateMode, comment: comment, onClickEdit: this.enableUpdateMode, onClickDelete: this.enableDeleteMode, onClickRemove: this.enableModerateMode }),
                    isDeleteMode &&
                        React.createElement(DeleteCommentMutation, { item: item, comment: comment, onCompleted: this.disableDeleteMode }, function (mutate, apolloState) { return (React.createElement(DeleteCommentConfirm, { onCancel: _this.disableDeleteMode, onConfirm: mutate, apolloState: apolloState })); }),
                    isModerateMode &&
                        React.createElement(ModerateCommentMutation, { item: item, comment: comment, onCompleted: this.disableModerateMode }, function (mutate, apolloState) { return (React.createElement(ConfirmRemoveComment, { onCancel: _this.disableModerateMode, onConfirm: mutate, apolloState: apolloState })); })))));
    };
    CommentComponent.defaultProps = {
        className: null,
        id: "comment",
        isUpdateMode: false,
        isDeleteMode: false,
        isModerateMode: false,
        onEnableUpdateMode: function () { },
        onDisableUpdateMode: function () { },
        onEnableDeleteMode: function () { },
        onDisableDeleteMode: function () { },
        onEnableModerateMode: function () { },
        onDisableModerateMode: function () { }
    };
    return CommentComponent;
}(Component));
export default CommentComponent;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
